import { DictionaryEnumResponse_CountryEnum } from '@acme/api';
import { useEffect, useState } from 'react';
import { countryStore } from './model';

export const useCountry = (countryId?: string) => {
  const [country, setCountry] = useState<
    DictionaryEnumResponse_CountryEnum | undefined
  >();
  const [countries, setCountries] = useState<
    DictionaryEnumResponse_CountryEnum[]
  >([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const loadCountry = async () => {
      try {
        setIsLoading(true);
        const countries = await countryStore.getCountries();

        setCountries(countries);

        if (countryId) {
          const foundCountry = countries.find(
            (c) => c.id === Number(countryId)
          );
          setCountry(foundCountry);
        }
      } catch (err) {
        setError(
          err instanceof Error ? err : new Error('Failed to load country')
        );
      } finally {
        setIsLoading(false);
      }
    };

    loadCountry();
  }, [countryId]);

  return { country, countries, isLoading, error };
};
